const US_STATE_LIST = [
  { display: 'Alabama', id: 'AL' },
  { display: 'Alaska', id: 'AK' },
  { display: 'Arizona', id: 'AZ' },
  { display: 'Arkansas', id: 'AR' },
  { display: 'California', id: 'CA' },
  { display: 'Colorado', id: 'CO' },
  { display: 'Connecticut', id: 'CT' },
  { display: 'Delaware', id: 'DE' },
  { display: 'Florida', id: 'FL' },
  { display: 'Georgia', id: 'GA' },
  { display: 'Hawaii', id: 'HI' },
  { display: 'Idaho', id: 'ID' },
  { display: 'Illinois', id: 'IL' },
  { display: 'Indiana', id: 'IN' },
  { display: 'Iowa', id: 'IA' },
  { display: 'Kansas', id: 'KS' },
  { display: 'Kentucky', id: 'KY' },
  { display: 'Louisiana', id: 'LA' },
  { display: 'Maine', id: 'ME' },
  { display: 'Maryland', id: 'MD' },
  { display: 'Massachusetts', id: 'MA' },
  { display: 'Michigan', id: 'MI' },
  { display: 'Minnesota', id: 'MN' },
  { display: 'Mississippi', id: 'MS' },
  { display: 'Missouri', id: 'MO' },
  { display: 'Montana', id: 'MT' },
  { display: 'Nebraska', id: 'NE' },
  { display: 'Nevada', id: 'NV' },
  { display: 'New Hampshire', id: 'NH' },
  { display: 'New Jersey', id: 'NJ' },
  { display: 'New Mexico', id: 'NM' },
  { display: 'New York', id: 'NY' },
  { display: 'North Carolina', id: 'NC' },
  { display: 'North Dakota', id: 'ND' },
  { display: 'Ohio', id: 'OH' },
  { display: 'Oklahoma', id: 'OK' },
  { display: 'Oregon', id: 'OR' },
  { display: 'Pennsylvania', id: 'PA' },
  { display: 'Rhode Island', id: 'RI' },
  { display: 'South Carolina', id: 'SC' },
  { display: 'South Dakota', id: 'SD' },
  { display: 'Tennessee', id: 'TN' },
  { display: 'Texas', id: 'TX' },
  { display: 'Utah', id: 'UT' },
  { display: 'Vermont', id: 'VT' },
  { display: 'Virginia', id: 'VA' },
  { display: 'Washington', id: 'WA' },
  { display: 'West Virginia', id: 'WV' },
  { display: 'Wisconsin', id: 'WI' },
  { display: 'Wyoming', id: 'WY ' },
  { display: 'District of Columbia (DC)', id: 'DC' },
  { display: 'American Samoa', id: 'AS' },
  { display: 'Guam', id: 'GU' },
  { display: 'Northern Mariana Islands', id: 'MP' },
  { display: 'Puerto Rico', id: 'PR' },
  { display: 'United States Minor Outlying Islands', id: 'UM' },
  { display: 'Virgin Islands, U.S.', id: 'VI' },
];

const CA_STATE_LIST = [
  { display: 'Alberta', id: 'AB' },
  { display: 'British Columbia', id: 'BC' },
  { display: 'Manitoba', id: 'MB' },
  { display: 'New Brunswick', id: 'NB' },
  { display: 'Newfoundland and Labrador', id: 'NL' },
  { display: 'Nova Scotia', id: 'NS' },
  { display: 'Northwest Territories', id: 'NT' },
  { display: 'Nunavut', id: 'NU' },
  { display: 'Ontario', id: 'ON' },
  { display: 'Prince Edward Island', id: 'PE' },
  { display: 'Quebec', id: 'QC' },
  { display: 'Saskatchewan', id: 'SK' },
  { display: 'Yukon', id: 'YT' },
];

export const COUNTRY_LIST = [
  { id: 'AF', display: 'Afghanistan', code3: 'AFG' },
  { id: 'AL', display: 'Albania', code3: 'ALB' },
  { id: 'DZ', display: 'Algeria', code3: 'DZA' },
  { id: 'AS', display: 'American Samoa', code3: 'ASM' },
  { id: 'AD', display: 'Andorra', code3: 'AND' },
  { id: 'AO', display: 'Angola', code3: 'AGO' },
  { id: 'AI', display: 'Anguilla', code3: 'AIA' },
  { id: 'AQ', display: 'Antarctica', code3: 'ATA' },
  { id: 'AG', display: 'Antigua and Barbuda', code3: 'ATG' },
  { id: 'AR', display: 'Argentina', code3: 'ARG' },
  { id: 'AM', display: 'Armenia', code3: 'ARM' },
  { id: 'AW', display: 'Aruba', code3: 'ABW' },
  { id: 'AU', display: 'Australia', code3: 'AUS' },
  { id: 'AT', display: 'Austria', code3: 'AUT' },
  { id: 'AZ', display: 'Azerbaijan', code3: 'AZE' },
  { id: 'BS', display: 'Bahamas', code3: 'BHS' },
  { id: 'BH', display: 'Bahrain', code3: 'BHR' },
  { id: 'BD', display: 'Bangladesh', code3: 'BGD' },
  { id: 'BB', display: 'Barbados', code3: 'BRB' },
  { id: 'BY', display: 'Belarus', code3: 'BLR' },
  { id: 'BE', display: 'Belgium', code3: 'BEL' },
  { id: 'BZ', display: 'Belize', code3: 'BLZ' },
  { id: 'BJ', display: 'Benin', code3: 'BEN' },
  { id: 'BM', display: 'Bermuda', code3: 'BMU' },
  { id: 'BT', display: 'Bhutan', code3: 'BTN' },
  { id: 'BO', display: 'Bolivia (Plurinational State of)', code3: 'BOL' },
  { id: 'BQ', display: 'Bonaire, Sint Eustatius and Saba', code3: 'BES' },
  { id: 'BA', display: 'Bosnia and Herzegovina', code3: 'BIH' },
  { id: 'BW', display: 'Botswana', code3: 'BWA' },
  { id: 'BV', display: 'Bouvet Island', code3: 'BVT' },
  { id: 'BR', display: 'Brazil', code3: 'BRA' },
  { id: 'IO', display: 'British Indian Ocean Territory ', code3: 'IOT' },
  { id: 'BN', display: 'Brunei Darussalam', code3: 'BRN' },
  { id: 'BG', display: 'Bulgaria', code3: 'BGR' },
  { id: 'BF', display: 'Burkina Faso', code3: 'BFA' },
  { id: 'BI', display: 'Burundi', code3: 'BDI' },
  { id: 'CV', display: 'Cabo Verde', code3: 'CPV' },
  { id: 'KH', display: 'Cambodia', code3: 'KHM' },
  { id: 'CM', display: 'Cameroon', code3: 'CMR' },
  { id: 'CA', display: 'Canada', code3: 'CAN', states: CA_STATE_LIST },
  { id: 'KY', display: 'Cayman Islands', code3: 'CYM' },
  { id: 'CF', display: 'Central African Republic', code3: 'CAF' },
  { id: 'TD', display: 'Chad', code3: 'TCD' },
  { id: 'CL', display: 'Chile', code3: 'CHL' },
  { id: 'CN', display: 'China', code3: 'CHN' },
  { id: 'CX', display: 'Christmas Island', code3: 'CXR' },
  { id: 'CC', display: 'Cocos (Keeling) Islands', code3: 'CCK' },
  { id: 'CO', display: 'Colombia', code3: 'COL' },
  { id: 'KM', display: 'Comoros', code3: 'COM' },
  { id: 'CD', display: 'Congo (the Democratic Republic of the)', code3: 'COD' },
  { id: 'CG', display: 'Congo', code3: 'COG' },
  { id: 'CK', display: 'Cook Islands', code3: 'COK' },
  { id: 'CR', display: 'Costa Rica', code3: 'CRI' },
  { id: 'HR', display: 'Croatia', code3: 'HRV' },
  { id: 'CU', display: 'Cuba', code3: 'CUB' },
  { id: 'CW', display: 'Curaçao', code3: 'CUW' },
  { id: 'CY', display: 'Cyprus', code3: 'CYP' },
  { id: 'CZ', display: 'Czechia', code3: 'CZE' },
  { id: 'CI', display: "Côte d'Ivoire", code3: 'CIV' },
  { id: 'DK', display: 'Denmark', code3: 'DNK' },
  { id: 'DJ', display: 'Djibouti', code3: 'DJI' },
  { id: 'DM', display: 'Dominica', code3: 'DMA' },
  { id: 'DO', display: 'Dominican Republic', code3: 'DOM' },
  { id: 'EC', display: 'Ecuador', code3: 'ECU' },
  { id: 'EG', display: 'Egypt', code3: 'EGY' },
  { id: 'SV', display: 'El Salvador', code3: 'SLV' },
  { id: 'GQ', display: 'Equatorial Guinea', code3: 'GNQ' },
  { id: 'ER', display: 'Eritrea', code3: 'ERI' },
  { id: 'EE', display: 'Estonia', code3: 'EST' },
  { id: 'SZ', display: 'Eswatini', code3: 'SWZ' },
  { id: 'ET', display: 'Ethiopia', code3: 'ETH' },
  { id: 'FK', display: 'Falkland Islands [Malvinas]', code3: 'FLK' },
  { id: 'FO', display: 'Faroe Islands', code3: 'FRO' },
  { id: 'FJ', display: 'Fiji', code3: 'FJI' },
  { id: 'FI', display: 'Finland', code3: 'FIN' },
  { id: 'FR', display: 'France', code3: 'FRA' },
  { id: 'GF', display: 'French Guiana', code3: 'GUF' },
  { id: 'PF', display: 'French Polynesia', code3: 'PYF' },
  { id: 'TF', display: 'French Southern Territories', code3: 'ATF' },
  { id: 'GA', display: 'Gabon', code3: 'GAB' },
  { id: 'GM', display: 'Gambia', code3: 'GMB' },
  { id: 'GE', display: 'Georgia', code3: 'GEO' },
  { id: 'DE', display: 'Germany', code3: 'DEU' },
  { id: 'GH', display: 'Ghana', code3: 'GHA' },
  { id: 'GI', display: 'Gibraltar', code3: 'GIB' },
  { id: 'GR', display: 'Greece', code3: 'GRC' },
  { id: 'GL', display: 'Greenland', code3: 'GRL' },
  { id: 'GD', display: 'Grenada', code3: 'GRD' },
  { id: 'GP', display: 'Guadeloupe', code3: 'GLP' },
  { id: 'GU', display: 'Guam', code3: 'GUM' },
  { id: 'GT', display: 'Guatemala', code3: 'GTM' },
  { id: 'GG', display: 'Guernsey', code3: 'GGY' },
  { id: 'GN', display: 'Guinea', code3: 'GIN' },
  { id: 'GW', display: 'Guinea-Bissau', code3: 'GNB' },
  { id: 'GY', display: 'Guyana', code3: 'GUY' },
  { id: 'HT', display: 'Haiti', code3: 'HTI' },
  { id: 'HM', display: 'Heard Island and McDonald Islands', code3: 'HMD' },
  { id: 'VA', display: 'Holy See', code3: 'VAT' },
  { id: 'HN', display: 'Honduras', code3: 'HND' },
  { id: 'HK', display: 'Hong Kong', code3: 'HKG' },
  { id: 'HU', display: 'Hungary', code3: 'HUN' },
  { id: 'IS', display: 'Iceland', code3: 'ISL' },
  { id: 'IN', display: 'India', code3: 'IND' },
  { id: 'ID', display: 'Indonesia', code3: 'IDN' },
  { id: 'IR', display: 'Iran (Islamic Republic of)', code3: 'IRN' },
  { id: 'IQ', display: 'Iraq', code3: 'IRQ' },
  { id: 'IE', display: 'Ireland', code3: 'IRL' },
  { id: 'IM', display: 'Isle of Man', code3: 'IMN' },
  { id: 'IL', display: 'Israel', code3: 'ISR' },
  { id: 'IT', display: 'Italy', code3: 'ITA' },
  { id: 'JM', display: 'Jamaica', code3: 'JAM' },
  { id: 'JP', display: 'Japan', code3: 'JPN' },
  { id: 'JE', display: 'Jersey', code3: 'JEY' },
  { id: 'JO', display: 'Jordan', code3: 'JOR' },
  { id: 'KZ', display: 'Kazakhstan', code3: 'KAZ' },
  { id: 'KE', display: 'Kenya', code3: 'KEN' },
  { id: 'KI', display: 'Kiribati', code3: 'KIR' },
  {
    id: 'KP',
    display: "Korea (the Democratic People's Republic of)",
    code3: 'PRK',
  },
  { id: 'KR', display: 'Korea (the Republic of)', code3: 'KOR' },
  { id: 'KW', display: 'Kuwait', code3: 'KWT' },
  { id: 'KG', display: 'Kyrgyzstan', code3: 'KGZ' },
  { id: 'LA', display: "Lao People's Democratic Republic", code3: 'LAO' },
  { id: 'LV', display: 'Latvia', code3: 'LVA' },
  { id: 'LB', display: 'Lebanon', code3: 'LBN' },
  { id: 'LS', display: 'Lesotho', code3: 'LSO' },
  { id: 'LR', display: 'Liberia', code3: 'LBR' },
  { id: 'LY', display: 'Libya', code3: 'LBY' },
  { id: 'LI', display: 'Liechtenstein', code3: 'LIE' },
  { id: 'LT', display: 'Lithuania', code3: 'LTU' },
  { id: 'LU', display: 'Luxembourg', code3: 'LUX' },
  { id: 'MO', display: 'Macao', code3: 'MAC' },
  { id: 'MG', display: 'Madagascar', code3: 'MDG' },
  { id: 'MW', display: 'Malawi', code3: 'MWI' },
  { id: 'MY', display: 'Malaysia', code3: 'MYS' },
  { id: 'MV', display: 'Maldives', code3: 'MDV' },
  { id: 'ML', display: 'Mali', code3: 'MLI' },
  { id: 'MT', display: 'Malta', code3: 'MLT' },
  { id: 'MH', display: 'Marshall Islands', code3: 'MHL' },
  { id: 'MQ', display: 'Martinique', code3: 'MTQ' },
  { id: 'MR', display: 'Mauritania', code3: 'MRT' },
  { id: 'MU', display: 'Mauritius', code3: 'MUS' },
  { id: 'YT', display: 'Mayotte', code3: 'MYT' },
  { id: 'MX', display: 'Mexico', code3: 'MEX' },
  { id: 'FM', display: 'Micronesia (Federated States of)', code3: 'FSM' },
  { id: 'MD', display: 'Moldova (the Republic of)', code3: 'MDA' },
  { id: 'MC', display: 'Monaco', code3: 'MCO' },
  { id: 'MN', display: 'Mongolia', code3: 'MNG' },
  { id: 'ME', display: 'Montenegro', code3: 'MNE' },
  { id: 'MS', display: 'Montserrat', code3: 'MSR' },
  { id: 'MA', display: 'Morocco', code3: 'MAR' },
  { id: 'MZ', display: 'Mozambique', code3: 'MOZ' },
  { id: 'MM', display: 'Myanmar', code3: 'MMR' },
  { id: 'NA', display: 'Namibia', code3: 'NAM' },
  { id: 'NR', display: 'Nauru', code3: 'NRU' },
  { id: 'NP', display: 'Nepal', code3: 'NPL' },
  { id: 'NL', display: 'Netherlands', code3: 'NLD' },
  { id: 'NC', display: 'New Caledonia', code3: 'NCL' },
  { id: 'NZ', display: 'New Zealand', code3: 'NZL' },
  { id: 'NI', display: 'Nicaragua', code3: 'NIC' },
  { id: 'NE', display: 'Niger', code3: 'NER' },
  { id: 'NG', display: 'Nigeria', code3: 'NGA' },
  { id: 'NU', display: 'Niue', code3: 'NIU' },
  { id: 'NF', display: 'Norfolk Island', code3: 'NFK' },
  { id: 'MP', display: 'Northern Mariana Islands', code3: 'MNP' },
  { id: 'NO', display: 'Norway', code3: 'NOR' },
  { id: 'OM', display: 'Oman', code3: 'OMN' },
  { id: 'PK', display: 'Pakistan', code3: 'PAK' },
  { id: 'PW', display: 'Palau', code3: 'PLW' },
  { id: 'PS', display: 'Palestine, State of', code3: 'PSE' },
  { id: 'PA', display: 'Panama', code3: 'PAN' },
  { id: 'PG', display: 'Papua New Guinea', code3: 'PNG' },
  { id: 'PY', display: 'Paraguay', code3: 'PRY' },
  { id: 'PE', display: 'Peru', code3: 'PER' },
  { id: 'PH', display: 'Philippines', code3: 'PHL' },
  { id: 'PN', display: 'Pitcairn', code3: 'PCN' },
  { id: 'PL', display: 'Poland', code3: 'POL' },
  { id: 'PT', display: 'Portugal', code3: 'PRT' },
  { id: 'PR', display: 'Puerto Rico', code3: 'PRI' },
  { id: 'QA', display: 'Qatar', code3: 'QAT' },
  { id: 'MK', display: 'Republic of North Macedonia', code3: 'MKD' },
  { id: 'RO', display: 'Romania', code3: 'ROU' },
  { id: 'RU', display: 'Russian Federation', code3: 'RUS' },
  { id: 'RW', display: 'Rwanda', code3: 'RWA' },
  { id: 'RE', display: 'Réunion', code3: 'REU' },
  { id: 'BL', display: 'Saint Barthélemy', code3: 'BLM' },
  {
    id: 'SH',
    display: 'Saint Helena, Ascension and Tristan da Cunha',
    code3: 'SHN',
  },
  { id: 'KN', display: 'Saint Kitts and Nevis', code3: 'KNA' },
  { id: 'LC', display: 'Saint Lucia', code3: 'LCA' },
  { id: 'MF', display: 'Saint Martin (French part)', code3: 'MAF' },
  { id: 'PM', display: 'Saint Pierre and Miquelon', code3: 'SPM' },
  { id: 'VC', display: 'Saint Vincent and the Grenadines', code3: 'VCT' },
  { id: 'WS', display: 'Samoa', code3: 'WSM' },
  { id: 'SM', display: 'San Marino', code3: 'SMR' },
  { id: 'ST', display: 'Sao Tome and Principe', code3: 'STP' },
  { id: 'SA', display: 'Saudi Arabia', code3: 'SAU' },
  { id: 'SN', display: 'Senegal', code3: 'SEN' },
  { id: 'RS', display: 'Serbia', code3: 'SRB' },
  { id: 'SC', display: 'Seychelles', code3: 'SYC' },
  { id: 'SL', display: 'Sierra Leone', code3: 'SLE' },
  { id: 'SG', display: 'Singapore', code3: 'SGP' },
  { id: 'SX', display: 'Sint Maarten (Dutch part)', code3: 'SXM' },
  { id: 'SK', display: 'Slovakia', code3: 'SVK' },
  { id: 'SI', display: 'Slovenia', code3: 'SVN' },
  { id: 'SB', display: 'Solomon Islands', code3: 'SLB' },
  { id: 'SO', display: 'Somalia', code3: 'SOM' },
  { id: 'ZA', display: 'South Africa', code3: 'ZAF' },
  {
    id: 'GS',
    display: 'South Georgia and the South Sandwich Islands',
    code3: 'SGS',
  },
  { id: 'SS', display: 'South Sudan', code3: 'SSD' },
  { id: 'ES', display: 'Spain', code3: 'ESP' },
  { id: 'LK', display: 'Sri Lanka', code3: 'LKA' },
  { id: 'SD', display: 'Sudan', code3: 'SDN' },
  { id: 'SR', display: 'Suriname', code3: 'SUR' },
  { id: 'SJ', display: 'Svalbard and Jan Mayen', code3: 'SJM' },
  { id: 'SE', display: 'Sweden', code3: 'SWE' },
  { id: 'CH', display: 'Switzerland', code3: 'CHE' },
  { id: 'SY', display: 'Syrian Arab Republic', code3: 'SYR' },
  { id: 'TW', display: 'Taiwan (Province of China)', code3: 'TWN' },
  { id: 'TJ', display: 'Tajikistan', code3: 'TJK' },
  { id: 'TZ', display: 'Tanzania, United Republic of', code3: 'TZA' },
  { id: 'TH', display: 'Thailand', code3: 'THA' },
  { id: 'TL', display: 'Timor-Leste', code3: 'TLS' },
  { id: 'TG', display: 'Togo', code3: 'TGO' },
  { id: 'TK', display: 'Tokelau', code3: 'TKL' },
  { id: 'TO', display: 'Tonga', code3: 'TON' },
  { id: 'TT', display: 'Trinidad and Tobago', code3: 'TTO' },
  { id: 'TN', display: 'Tunisia', code3: 'TUN' },
  { id: 'TR', display: 'Turkey', code3: 'TUR' },
  { id: 'TM', display: 'Turkmenistan', code3: 'TKM' },
  { id: 'TC', display: 'Turks and Caicos Islands', code3: 'TCA' },
  { id: 'TV', display: 'Tuvalu', code3: 'TUV' },
  { id: 'UG', display: 'Uganda', code3: 'UGA' },
  { id: 'UA', display: 'Ukraine', code3: 'UKR' },
  { id: 'AE', display: 'United Arab Emirates', code3: 'ARE' },
  {
    id: 'GB',
    display: 'United Kingdom of Great Britain and Northern Ireland',
    code3: 'GBR',
  },
  {
    id: 'UM',
    display: 'United States Minor Outlying Islands',
    code3: 'UMI',
  },
  {
    id: 'US',
    display: 'United States of America',
    code3: 'USA',
    states: US_STATE_LIST,
  },
  { id: 'UY', display: 'Uruguay', code3: 'URY' },
  { id: 'UZ', display: 'Uzbekistan', code3: 'UZB' },
  { id: 'VU', display: 'Vanuatu', code3: 'VUT' },
  { id: 'VE', display: 'Venezuela (Bolivarian Republic of)', code3: 'VEN' },
  { id: 'VN', display: 'Viet Nam', code3: 'VNM' },
  { id: 'VG', display: 'Virgin Islands (British)', code3: 'VGB' },
  { id: 'VI', display: 'Virgin Islands (U.S.)', code3: 'VIR' },
  { id: 'WF', display: 'Wallis and Futuna', code3: 'WLF' },
  { id: 'EH', display: 'Western Sahara', code3: 'ESH' },
  { id: 'YE', display: 'Yemen', code3: 'YEM' },
  { id: 'ZM', display: 'Zambia', code3: 'ZMB' },
  { id: 'ZW', display: 'Zimbabwe', code3: 'ZWE' },
  { id: 'AX', display: 'Åland Islands', code3: 'ALA' },
];

export const US_LAT_COORD = '37.09024';
export const US_LONG_COORD = '-95.712891';
